export const initialState = {
    page: 0,
    rowsPerPage: 10,
    name: ''
};

// ==============================|| AUTH REDUCER ||============================== //

const levelReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case 'SET_PAGE_LEVEL':
            return {
                ...state,
                page: actions.payload
            };
        case 'SET_ROWS_PER_PAGE_LEVEL':
            return {
                ...state,
                rowsPerPage: actions.payload
            };
        case 'SET_NAME_LEVEL_FILTER':
            return {
                ...state,
                name: actions.payload
            };
        case 'SET_CLEAR_LEVEL_FILTER':
            return {
                ...state,
                name: ''
            };
        default:
            return state;
    }
};

export default levelReducer;
